import { defaultInitialValues } from '../formState'
import { DriverFormValues, GpsDeviceIdOption } from '../types'

export function computeFormInitialValues(
  trackingProvider: uui.domain.server.gps.TrackingProvider,
  gpsDeviceIdOptions: GpsDeviceIdOption[],
  extDriver?: uui.domain.client.rm.ExtendedDriver,
  firstEligibleGpsDeviceId?: string,
): DriverFormValues {
  const firstEligibleGpsOption = gpsDeviceIdOptions.find(
    option => option.value === firstEligibleGpsDeviceId,
  )

  if (!extDriver) {
    return {
      ...defaultInitialValues,
      gpsDeviceId: trackingProvider === 'telematics' ? null : (firstEligibleGpsOption ?? null),
    }
  }

  const {
    driver: {
      id,
      name,
      deployment: { email },
      mobileFutureDaysVisibility,
      summarizeFutureMobileRoute,
      barcodeAttachmentAllowed,
    },
  } = extDriver

  const trackDriver = trackingProvider === 'telematics' ? false : extDriver.type === 'linked'
  const gpsDeviceOptionId =
    trackingProvider === 'telematics'
      ? ''
      : extDriver.type === 'linked'
        ? extDriver.device.deviceId
        : (firstEligibleGpsDeviceId ?? '')

  const gpsDeviceId = gpsDeviceIdOptions.find(option => option.value === gpsDeviceOptionId) ?? null

  return {
    id,
    name,
    email,
    'new-password': '',
    gpsDeviceId,
    trackDriver,
    mobileFutureDaysVisibility: `${mobileFutureDaysVisibility}`,
    summarizeFutureMobileRoute,
    barcodeAttachmentAllowed,
  }
}
